import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5.2.8v11.834l2.517-2.517.566.566L4.8 14.166l-3.483-3.483.566-.566L4.4 12.634V.8h.8z" fill="currentColor" /><path fill="currentColor" d="M8 3.2h6.4V4H8zM9.6 7.6h4.8v.8H9.6zM11.2 12h3.2v.8h-3.2z" /></svg>;